"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFreebie = exports.useBestCoupon = exports.useProductCoupons = exports.useFeaturedCoupons = void 0;
const react_1 = require("react");
const navbar_1 = require("../context/navbar");
const helpers_1 = require("../helpers");
const types_1 = require("../types");
const useFeaturedCoupons = (isNumber = false) => {
    const { coupons, cartItems } = (0, navbar_1.useNavbar)();
    const featuredCoupons = (0, react_1.useMemo)(() => (coupons || [])
        .filter((coupon) => coupon.couponType !== types_1.CouponType.FREEBIE)
        .map((coupon) => (0, helpers_1.getCouponDiscount)(coupon, cartItems, isNumber)), [coupons, cartItems]);
    const featuredCouponsSorted = featuredCoupons.sort((a, b) => {
        if (a.allowed && !b.allowed) {
            return -1;
        }
        else if (!a.allowed && b.allowed) {
            return 1;
        }
        if (a.discount && b.discount) {
            return a.discount - b.discount;
        }
        return 0;
    });
    const featuredCouponSortedByPriority = featuredCouponsSorted.sort((a, b) => {
        var _a, _b;
        const priorityA = (_a = a === null || a === void 0 ? void 0 : a.coupon) === null || _a === void 0 ? void 0 : _a.priority;
        const priorityB = (_b = b === null || b === void 0 ? void 0 : b.coupon) === null || _b === void 0 ? void 0 : _b.priority;
        // Handle null priorities by treating them as the lowest possible value
        if (priorityA === null)
            return 1;
        if (priorityB === null)
            return -1;
        // Compare the priorities as numbers
        return priorityA - priorityB;
    });
    const filteredFeaturedCouponSortedByPriority = featuredCouponSortedByPriority.filter((coupon) => { var _a; return (_a = coupon === null || coupon === void 0 ? void 0 : coupon.coupon) === null || _a === void 0 ? void 0 : _a.isFeatured; });
    return {
        featuredCouponsSorted,
        filteredFeaturedCoupons: filteredFeaturedCouponSortedByPriority,
    };
};
exports.useFeaturedCoupons = useFeaturedCoupons;
const useProductCoupons = (product, variant) => {
    const coupons = (0, navbar_1.useCoupons)();
    const currentProductItem = (0, react_1.useMemo)(() => {
        if (product) {
            const { variants } = product;
            const selectedVariant = variants === null || variants === void 0 ? void 0 : variants.items.find((v) => (v === null || v === void 0 ? void 0 : v.id) === variant);
            return Object.assign(Object.assign({}, product), { price: (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price) || product.price, qty: 1 });
        }
    }, [product, variant]);
    const productCoupons = (0, react_1.useMemo)(() => {
        if (coupons && currentProductItem) {
            return (coupons || [])
                .filter((coupon) => coupon.couponType !== types_1.CouponType.BUY_X_AT_Y &&
                coupon.couponType !== types_1.CouponType.BUY_X_GET_Y &&
                coupon.couponType !== types_1.CouponType.FREEBIE &&
                (coupon === null || coupon === void 0 ? void 0 : coupon.isPDPFeatured))
                .map((coupon) => (0, helpers_1.getCouponDiscount)(coupon, [currentProductItem]))
                .filter((coupon) => coupon.allowed)
                .sort((a, b) => ((a.discount || 0) > (b.discount || 0) ? -1 : 1));
        }
    }, [coupons, currentProductItem]);
    const [bestCoupon] = productCoupons ? productCoupons : [];
    return bestCoupon;
};
exports.useProductCoupons = useProductCoupons;
const useBestCoupon = () => {
    var _a;
    const { cartItems } = (0, navbar_1.useNavbar)();
    const { featuredCouponsSorted } = (0, exports.useFeaturedCoupons)();
    const eligibleCoupons = featuredCouponsSorted.filter((f) => { var _a; return ((_a = f.coupon) === null || _a === void 0 ? void 0 : _a.autoApply) && f.allowed; });
    const sortedCoupons = eligibleCoupons.sort((a, b) => {
        const discountA = (0, helpers_1.getCouponDiscount)(a.coupon, cartItems);
        const discountB = (0, helpers_1.getCouponDiscount)(b.coupon, cartItems);
        return (discountB === null || discountB === void 0 ? void 0 : discountB.discount) - (discountA === null || discountA === void 0 ? void 0 : discountA.discount);
    });
    const [bestCoupon] = sortedCoupons;
    return (_a = bestCoupon === null || bestCoupon === void 0 ? void 0 : bestCoupon.coupon) === null || _a === void 0 ? void 0 : _a.code;
};
exports.useBestCoupon = useBestCoupon;
const useFreebie = () => {
    const { coupons } = (0, navbar_1.useNavbar)();
    const [freebie] = (coupons || []).filter((coupon) => coupon.couponType === types_1.CouponType.FREEBIE);
    return freebie;
};
exports.useFreebie = useFreebie;
